import { BigNumber } from "../external/bignumber.js/bignumber.js";
const SW_VERSION_STORAGE_KEY = "push-notification-register-status";
const SW_MEMBER_ID_STORAGE_KEY = "push-notification-member-register";
const NOTIFICATION_ACTION = {
  OPEN_LINK_NEW_TAB: "open-link-new-tab",
  // open a link in new tab
  OPEN_LINK_CURRENT_PAGE: "open-link-current-page",
  // open a link in current page
  OPEN_LINK_NEW_WINDOW: "open-link-new-window",
  // open a link in new window
  LOAD_PAGE: "load-page"
  // open current page
};
const BN_ZERO = new BigNumber(0);
const BN_ONE = new BigNumber(1);
export {
  BN_ONE,
  BN_ZERO,
  NOTIFICATION_ACTION,
  SW_MEMBER_ID_STORAGE_KEY,
  SW_VERSION_STORAGE_KEY
};
